import { ContainerModule, interfaces } from 'inversify';
import { ISegmentationOrderBl, SegmentationOrderBl } from './segmentationsOrder.Bl';

export const segmentationsModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(ISegmentationOrderBl.$).to(SegmentationOrderBl).inSingletonScope();
});
